<template>
  <div>
    <div v-if="stages.length">
      <v-card class="pa-3 mb-3 sticky" v-for="(item, index) in stages" :key="index">
        <h4>
          {{ index + 1 }} - {{ item.heading }}
          <v-icon v color="blue" class="float-left" v-if="item.step_complete">
            mdi-check-decagram-outline
          </v-icon>
        </h4>
        <v-divider></v-divider>

        <FormBlocks
          v-if="item.blocks"
          v-model="item.blocks"
          :filled.sync="item.blocksFilled"
          :item-id="refID"
          :model="model"
          :ref="`formBlocks_${item.id}`"
          :disabled="!item.action"
        ></FormBlocks>

        <div v-if="item.action && item.action.displayBlocks">
          <div v-for="(block, index) in item.action.displayBlocks" :key="index">
            <div v-if="block == 'approvalBlock' && (!item.blocks || item.blocksFilled)">
              <RemarksBlock
                :action="item.action"
                :refID="refID"
                @processed="getStages"
                :model="model"
                :before-process="saveFormBlocks"
              />
            </div>
          </div>
        </div>

        <div v-if="item.applied_actions">
          <div v-for="(log, index) in item.applied_actions" :key="index" style="max">
            <v-chip x-small class="float-left text-uppercase" dark>
              {{ log.to_status }} - {{ log.decision }}
            </v-chip>
            <div class="d-flex items-center">
              <v-avatar color="primary" size="30">
                <img :src="log.staff.profile_url" />
              </v-avatar>

              <div class="ml-2">
                <small>{{ log.staff.emp_label_dhi_position }}</small>
                <div style="font-size: 10px">{{ $localeDateTime(log.created_at) }}</div>
              </div>
            </div>
            <div v-if="log.remarks">{{ log.remarks }}</div>

            <v-divider></v-divider>
          </div>
        </div>
      </v-card>
    </div>

    <div v-else>
      <h3>Approval steps not defined. Contact IT.</h3>
    </div>
  </div>
</template>

<script>
import RemarksBlock from './RemarksBlock.vue'
import FormBlocks from '../form-blocks/Blocks.vue'

export default {
  data: () => ({
    stages: [],
    blocksFilled: false,
  }),
  components: {
    RemarksBlock,
    FormBlocks,
  },
  props: ['model', 'refID'],
  watch: {
    refID: {
      handler: function () {
        this.getStages()
      },
      immediate: true,
    },
  },
  methods: {
    async saveFormBlocks() {
      let promises = []
      for (let step of this.stages) {
        let ref = `formBlocks_${step.id}`
        if (!(step.blocks?.length && this.$refs[ref])) continue

        for (let block of this.$refs[ref]) {
          promises.push(block.save())
        }
      }
      return await Promise.all(promises)
    },
    getStages() {
      return this.$axios
        .get(`/api/approval_stages/getApprovalStages/${this.model}/${this.refID}`)
        .then(({ data }) => (this.stages = data))
        .finally(() => (this.loading = false))
    },
  },
}
</script>
